import { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { Crest } from "@/components/Crest";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Καλώς ήρθατε!");
      navigate("/admin");
    } catch (err) {
      toast.error(err?.message === "Invalid login credentials" ? "Λάθος email ή κωδικός" : (err?.message || "Αποτυχία σύνδεσης"));
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full rounded-lg border border-white/15 bg-royal/60 px-4 py-3 text-ice placeholder-ice/40 outline-none transition-all focus:border-gold focus:ring-2 focus:ring-gold/40";

  return (
    <div className="grid min-h-screen place-items-center bg-navy px-5">
      <div className="w-full max-w-md rounded-2xl border border-white/10 bg-royal/30 p-8 sm:p-10">
        <div className="flex flex-col items-center text-center">
          <Crest size={80} />
          <h1 className="font-heading mt-5 text-3xl font-900 uppercase tracking-tight text-white">
            Διαχείριση
          </h1>
          <p className="mt-1 text-sm text-ice/70">Ρεάλ Δυτικής Αττικής</p>
        </div>
        <form onSubmit={submit} className="mt-8 space-y-5" data-testid="login-form">
          <div>
            <label className="mb-1.5 block text-sm font-600 text-ice">Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} placeholder="email@example.com" data-testid="login-email" required />
          </div>
          <div>
            <label className="mb-1.5 block text-sm font-600 text-ice">Κωδικός</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} placeholder="••••••••" data-testid="login-password" required />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-brand px-8 py-3.5 font-display text-lg font-700 uppercase tracking-wide text-white transition-all hover:bg-brand/80 hover:shadow-[0_0_30px_rgba(60,115,192,0.6)] disabled:opacity-60"
          >
            <Lock size={18} /> {loading ? "Σύνδεση..." : "Σύνδεση"}
          </button>
        </form>
        <Link to="/" className="mt-6 block text-center text-sm text-ice/60 hover:text-gold">
          ← Επιστροφή στην ιστοσελίδα
        </Link>
      </div>
    </div>
  );
}
